module.exports = __webpack_public_path__ + "img/flybit-small-logo.5a59320.svg";